<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { startRealtime, stopRealtime } from '@/lib/realtime'
import { Toaster } from 'vue-sonner'
import AppSidebar from '@/components/AppSidebar.vue'
import NewsDialog from '@/components/NewsDialog.vue'
import { ULTIMA, newsOpen } from '@/lib/novidades'
import { api } from '@/lib/api'

const route = useRoute()
const auth = useAuthStore()

// Telas "bare" (ex.: login) não usam o shell com sidebar.
const bare = computed(() => route.meta.layout === 'bare')
const fullPage = computed(() => route.matched.some(record => record.name === 'chamado'))

// Novidades: uma vez por versão para quem é da equipe (terceiros não veem). Fica gravado no servidor.
const showNews = computed(() => !bare.value && auth.user && !auth.user.external && (newsOpen.value || auth.user.news_seen_version !== ULTIMA.version))
const closeNews = () => {
  newsOpen.value = false
  if (auth.user.news_seen_version === ULTIMA.version) return
  auth.user.news_seen_version = ULTIMA.version
  // Se falhar, a janela só volta no próximo login: nada a avisar.
  api('/api/me/news_seen', { method: 'POST', body: { version: ULTIMA.version } }).catch(() => {})
}

// Realtime (ActionCable): liga ao autenticar, desliga no logout.
watch(
  () => auth.isAuthenticated,
  authed => (authed ? startRealtime() : stopRealtime()),
  { immediate: true }
)
</script>

<template>
  <Toaster position="top-right" rich-colors close-button />

  <div v-if="bare" class="min-h-screen bg-slate-50">
    <router-view />
  </div>

  <div v-else class="desk-shell flex h-screen text-slate-800">
    <AppSidebar />
    <div class="flex min-w-0 flex-1 flex-col">
      <main
        class="min-h-0 flex-1 overflow-auto"
        :class="fullPage ? 'p-0' : 'p-4 sm:p-6 lg:p-7'"
      >
        <router-view />
      </main>
    </div>
    <NewsDialog v-if="showNews" @close="closeNews" />
  </div>
</template>
